const state = {
    openDialog: null,
};

const getters = {
    openDialog: state => {
        return state.openDialog;
    },
};

const actions = {
    setOpenDialog(context, dialogHandle) {
        context.commit('openDialog', dialogHandle);
    },
    closeOpenDialog(context) {
        context.commit('openDialog', null);
    },
};

const mutations = {
    openDialog(state, dialogHandle) {
        state.openDialog = dialogHandle;
    },
};

export default {
    state,
    getters,
    actions,
    mutations,
};